import React from 'react';

export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="sft-panel" style={{ padding: 24 }}>
          <h2 style={{ color: 'var(--danger)', marginBottom: 12 }}>Ошибка загрузки</h2>
          <pre style={{ background: 'var(--bg)', padding: 16, borderRadius: 'var(--radius)', overflow: 'auto', fontSize: 13 }}>
            {this.state.error?.message || String(this.state.error)}
          </pre>
          <p className="sft-hint" style={{ marginTop: 16 }}>Откройте консоль браузера (F12 → Console) для подробностей.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
